import type { ReactElement } from 'react';

/**
 * Suspense fallback for a not-yet-loaded route chunk (B2 code splitting).
 * Practically visible only on a cold client-side navigation race (router
 * transitions keep the previous page); deliberately chrome-only so nothing
 * flashes claims or layout.
 */
export function RouteFallback(): ReactElement {
  return <main id="main" aria-busy="true" className="min-h-screen bg-[color:var(--bd-page)]" />;
}
